import { action, computed, observable } from 'mobx';

import { ViewController } from '@estee/elc-service';

import { DropdownDataStore } from '~repositories/DropdownDataStore';
import { UserRepository } from '~repositories/UserRepository';

import { LanguageSwitcherConfiguration, PreferredLanguage } from './LanguageSwitcher';

interface ILanguageSwitcherController {
    dropdownDataStore: DropdownDataStore;
    userRepository: UserRepository;
}

export class LanguageSwitcherController extends ViewController {
    private dropdownDataStore: DropdownDataStore;
    private userRepository: UserRepository;

    @observable private languages: PreferredLanguage[];
    @observable private currentLanguage: string;
    @observable private staticLookupName: string;
    constructor({ dropdownDataStore, userRepository }: ILanguageSwitcherController) {
        super();
        this.dropdownDataStore = dropdownDataStore;
        this.userRepository = userRepository;
    }

    @computed
    public get data() {
        const config = this.dropdownDataStore.getStaticOptions(this.staticLookupName);
        const searchParameter = window.location.search;

        return this.languages?.map((language) => {
            return {
                ...language,
                redirectedURL: `${language.redirectedURL}${searchParameter}`,
                isActive: this.currentLanguage === language.name,
                label: config.find((c) => c.value === language.languageIndex?.toString())?.label
            };
        }) as PreferredLanguage[];
    }

    @action
    public loaded = async (
        language: string,
        { languages, staticLookupName }: LanguageSwitcherConfiguration
    ) => {
        const { name, languageId } =
            languages.find(
                ({ languageKey }) => languageKey?.toUpperCase() === language?.toUpperCase()
            ) ||
            languages.find(({ isDefault }) => isDefault) ||
            languages[0];
        this.userRepository.userFormStore?.setFieldValue('languageId', languageId.toString());
        this.currentLanguage = name;
        this.languages = languages;
        this.staticLookupName = staticLookupName || '';
        staticLookupName && (await this.dropdownDataStore.loadStaticLookupData(staticLookupName));
    };
}
